import { showPrivacyPolicyModalBus } from '@/event/main/information/showPrivacyPolicyModalBus'

export function toggleShowPrivacyPolicyModal() {
  showPrivacyPolicyModalBus.value = !showPrivacyPolicyModalBus.value
}
